import languageJson from './language.json';

// Goto https://www.w3schools.com/JSREF/jsref_tolocalestring.asp to find the date style for your country.
export const dateStyle= 'de-AT';

export const language = languageJson;